"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"

export default function BestSellersHeading() {
  const { t } = useFrontendPreferences()

  return (
    <div className="sahil-reference-section-heading">
      <div>
        <p>{t.bestSellers.eyebrow}</p>
        <h2>{t.bestSellers.title}</h2>
      </div>
      <span>{t.bestSellers.hint}</span>
    </div>
  )
}
